/**
 * Mock 模块：heart_voyage_stage_info
 * 默认已绑定普通形态：LV.12、3720/5000、可领、3 船路线。
 * next_level_rewards 默认 6 条，对齐盲盒奖励弹窗稿面 3×2（VoyageContent 成长卡若只需 4 格可另切 Mock）。
 * @see mockMd/heart_voyage_stage_info.md
 */
import type {HeartVoyageStageInfoData, TaskReward} from '../types'
import {StageActionStatus} from '../types'
import {storiesReward} from '../components/BlindBoxRewardModal/stories-images'

const MOCK_REWARD_DESC_NAME = 'Event Wall of Honor*2day'
export const MOCK_REWARD_ICON = storiesReward

const mockReward = (id: number): TaskReward => ({
  id,
  icon: MOCK_REWARD_ICON,
  desc: MOCK_REWARD_DESC_NAME,
  privilege_id: 101,
  has_show_effect: true,
  quantity: 2,
  reward_type: 1,
})

const nextLevelRewards: TaskReward[] = [
  mockReward(9010),
  mockReward(9011),
  mockReward(9012),
  mockReward(9013),
  mockReward(9014),
  mockReward(9015),
]

/** @see mockMd/heart_voyage_stage_info.md · 默认 = 稿面普通形态 */
export const HeartVoyageStageInfoMock: HeartVoyageStageInfoData = {
  err_msg: '',
  affinity: 3720,
  ship_level: 12,
  ship_form: 2,
  cur_progress: 3720,
  need_affinity: 5000,
  form_stages: [
    {level: 2, form_id: 1, total_affinity: 22500, rewards: [mockReward(9001)]},
    {level: 3, form_id: 2, total_affinity: 22500, rewards: [mockReward(9002)]},
    {level: 4, form_id: 3, total_affinity: 22500, rewards: [mockReward(9003)]},
  ],
  loop_mode: false,
  action_status: StageActionStatus.Claimable,
  next_level_rewards: nextLevelRewards,
  unlock_all_forms: false,
}

/** 全解锁循环；非默认 VRT */
export const HeartVoyageStageInfoLoopMock: HeartVoyageStageInfoData = {
  ...HeartVoyageStageInfoMock,
  loop_mode: true,
  unlock_all_forms: true,
  action_status: StageActionStatus.Locked,
}

/** 空奖池仍开窗；无 state-empty，不进默认 Preview */
export const HeartVoyageStageInfoEmptyMock: HeartVoyageStageInfoData = {
  ...HeartVoyageStageInfoMock,
  next_level_rewards: [],
}

/** 对方可领：去提醒；`?state=remind` */
export const HeartVoyageStageInfoRemindMock: HeartVoyageStageInfoData = {
  ...HeartVoyageStageInfoMock,
  action_status: StageActionStatus.RemindPeer,
}

/** 5 船路线滑动验收；`?state=route5` */
export const HeartVoyageStageInfoRoute5Mock: HeartVoyageStageInfoData = {
  ...HeartVoyageStageInfoMock,
  form_stages: [
    {level: 1, form_id: 1, total_affinity: 10000, rewards: [mockReward(9001)]},
    {level: 2, form_id: 2, total_affinity: 20000, rewards: [mockReward(9002)]},
    {level: 3, form_id: 3, total_affinity: 30000, rewards: [mockReward(9003)]},
    {level: 4, form_id: 4, total_affinity: 40000, rewards: [mockReward(9004)]},
    {level: 5, form_id: 5, total_affinity: 50000, rewards: [mockReward(9005)]},
  ],
}

export function resolveStageInfoMock(): HeartVoyageStageInfoData {
  return HeartVoyageStageInfoMock
}

export const HeartVoyageStageInfoGuideMock = {
  err_msg: '',
  affinity: 0,
  ship_level: 1,
  ship_form: 1,
  cur_progress: 0,
  need_affinity: 1000,
  form_stages: [
    {
      level: 1,
      form_id: 1,
      total_affinity: 0,
      rewards: [],
    },
    {
      level: 3,
      form_id: 2,
      total_affinity: 3000,
      rewards: [
        {
          id: 171173,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
        {
          id: 171177,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
    },
    {
      level: 5,
      form_id: 3,
      total_affinity: 10000,
      rewards: [
        {
          id: 171174,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
        {
          id: 171178,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
    },
    {
      level: 7,
      form_id: 4,
      total_affinity: 21000,
      rewards: [
        {
          id: 171175,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
        {
          id: 171179,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
    },
    {
      level: 9,
      form_id: 5,
      total_affinity: 36000,
      rewards: [
        {
          id: 171176,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
        {
          id: 171180,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
    },
  ],
  loop_mode: false,
  action_status: 0,
  next_level_rewards: [
    {
      id: 171181,
      icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
      desc: '‪Coins*100',
      privilege_id: null,
      car_effect: null,
      has_show_effect: false,
      quantity: 100,
      reward_type: 4,
    },
    {
      id: 171182,
      icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
      desc: '‪Coins*100',
      privilege_id: null,
      car_effect: null,
      has_show_effect: false,
      quantity: 100,
      reward_type: 4,
    },
  ],
  unlock_all_forms: false,
} as unknown as HeartVoyageStageInfoData
